import { ResponsiveBackgroundImage } from '../autoload/ResponsiveBackgroundImage';
import { carousel } from '../partials/carousel';
import { threeImageCarousel } from '../partials/three-image-carousel';
import { smallCarousel } from '../partials/small-carousel';

export default {
  init() {
    // JavaScript to be fired on all pages
    if(document.querySelector('.js-carousel')) {
      carousel();
    }

    if(document.querySelector('.js-three-image-carousel')) {
      threeImageCarousel();
    }

    if(document.querySelector('.js-small-carousel')) {
      smallCarousel();
    }

    this.waypointsInit();
    this.bgImages();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  waypointsInit() {
    //inline waypoints
    function onScrollInit( items, trigger ) {
      items.each( function() {
        let osElement = $(this),
          osAnimationClass = osElement.attr('data-os-animation'),
          osAnimationDelay = osElement.attr('data-os-animation-delay'),
          osAnimationOffset = osElement.attr('data-os-animation-offset');

        if (osAnimationDelay) {
          osElement.css({
            '-webkit-animation-delay':  osAnimationDelay,
            '-moz-animation-delay':     osAnimationDelay,
            'animation-delay':          osAnimationDelay,
          });
        }

        if (!osAnimationOffset) {
          osAnimationOffset = '85%';
        }

        let osTrigger = ( trigger ) ? trigger : osElement;

        new window.Waypoint({
          element: osTrigger,
          handler: function() {
            osElement.addClass('animated').addClass(osAnimationClass);
            this.destroy();
          },
          offset: osAnimationOffset,
        });
      });
    }
    onScrollInit( $('.os-animation') );
  },
  bgImages() {
    const bgImages = document.querySelectorAll('.js-bg-image');
    if(bgImages.length) {
      for (let i = 0; i < bgImages.length; i++) {
        new ResponsiveBackgroundImage(bgImages[i]);
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js